import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle, secondaryButtonStyle } from '../../shared/styles/buttons.styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize, spacing, radius } = redesignTheme;

export const useResourceCardStyles = makeStyles(() => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    height: '100%',
    padding: spacing.sm,
    borderRadius: radius.sm,
    border: `1px solid ${colors.surfaceBorder}`,
    backgroundColor: colors.surface,
    boxSizing: 'border-box',
  },
  cardCover: {
    width: '100%',
    aspectRatio: '148 / 208',
    borderRadius: 5,
    overflow: 'hidden',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
  },
  cardCoverDimmed: {
    filter: 'brightness(0.6)',
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    gap: 14,
    width: '100%',
    minHeight: 0,
  },
  cardTitleBlock: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 64,
  },
  cardTitle: {
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.base,
    color: colors.textBody,
    lineHeight: 1.25,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  cardTitleSpacer: {
    flex: 1,
    minHeight: 0,
  },
  progressRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 11,
    width: '100%',
    minHeight: 16,
    flexShrink: 0,
  },
  progressRowPlaceholder: {
    minHeight: 16,
    flexShrink: 0,
  },
  progressTrack: {
    flex: 1,
    height: 4,
    borderRadius: radius.sm,
    backgroundColor: colors.progressTrack,
    overflow: 'hidden',
  },
  progressTrackNotStarted: {
    flex: 1,
    height: 4,
    borderRadius: radius.sm,
    backgroundColor: colors.progressTrackNotStarted,
    overflow: 'hidden',
  },
  progressTrackMuted: {
    flex: 1,
    height: 4,
    borderRadius: radius.sm,
    backgroundColor: colors.progressTrackMuted,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    borderRadius: radius.sm,
    backgroundColor: colors.primary,
  },
  progressFillSuccess: {
    height: '100%',
    borderRadius: radius.sm,
    backgroundColor: colors.success,
  },
  progressLabel: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.xs,
    color: 'rgba(0, 0, 0, 0.4)',
    whiteSpace: 'nowrap',
  },
  cardButton: {
    ...secondaryButtonStyle,
    width: '100%',
    marginTop: 'auto',
  },
  cardButtonPrimary: {
    ...primaryButtonStyle,
    width: '100%',
    marginTop: 'auto',
    transition: 'opacity 0.15s ease',
  },
  cardActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
    width: '100%',
    marginTop: 'auto',
  },
  cardActionButton: {
    ...secondaryButtonStyle,
    width: '100%',
    marginTop: 0,
  },
  cardActionButtonPrimary: {
    ...primaryButtonStyle,
    width: '100%',
    marginTop: 0,
    transition: 'opacity 0.15s ease',
  },
  cardMeta: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    flexShrink: 0,
    fontSize: fontSize.xs,
    color: colors.brown,
  },
  metaRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 19,
    width: '100%',
  },
  metaLabel: {
    flex: 1,
    fontFamily: fonts.opensansBold,
    lineHeight: 'normal',
  },
  metaValue: {
    fontFamily: fonts.opensans,
    lineHeight: 'normal',
    whiteSpace: 'nowrap',
  },
}));
